<div class="info-header">
  <div class="container-fluid lh-container-fluid">
    <div class="flex">
      <div *ngIf="!error && !!shop" class="heading-5">
        <a class="breadcrumb-link" [routerLink]="'/dashboard'">{{ shop.name }}</a>
        <span class="breadcrumb-divider">></span>{{ 'BOOKINGS' | translate }}
      </div>

      <h1 class="heading-5" *ngIf="error">{{ 'NO_BOOKING_FOUND' | translate }}</h1>

      <div *ngIf="bookings" class="filter">
        <div class="btn-group">
          <button
            id="showIncidentBookings"
            (click)="showTab('Incidents')"
            class="btn btn-primary category"
            [class.active]="currentTab === 'Incidents'"
          >
            {{ 'STORAGE_LOCATION_BOOKINGS_TAB_INCIDENTS' | translate }}
          </button>

          <button
            id="showActiveBookings"
            (click)="showTab('Active')"
            class="btn btn-primary category"
            [class.active]="currentTab === 'Active'"
          >
            {{ 'STORAGE_LOCATION_BOOKINGS_TAB_ACTIVE' | translate }}
          </button>

          <button
            id="showAllBookings"
            (click)="showTab('All')"
            class="btn btn-primary category"
            [class.active]="currentTab === 'All'"
          >
            {{ 'STORAGE_LOCATION_BOOKINGS_TAB_ALL' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid lh-container-fluid">
  <div class="booking-period">
    <div *ngIf="isTopDatePaginationVisible" class="period-nav">
      <div class="text">
        {{ fromDate | lhMoment: 'MMM DD' | uppercaseFirstLetter }} - {{ toDate | lhMoment: 'MMM DD' }}
      </div>

      <button id="showEarlier" class="btn btn-default pagination" (click)="showEarlier()">
        <i class="icon-prev"></i>
      </button>
      <button id="showLater" class="btn btn-default pagination" (click)="showLater()">
        <i class="icon-next"></i>
      </button>
      <button id="showToday" class="btn btn-info btn-md today" (click)="showToday()">
        {{ 'TODAY' | translate }}
      </button>
    </div>

    <div *ngIf="!isTopDatePaginationVisible" class="period-nav">
      <div class="text">&nbsp;</div>
    </div>

    <button id="refreshBookings" class="btn btn-info btn-md refresh" (click)="showTab(currentTab, true)">
      <i class="icon-refresh"></i>
    </button>
  </div>

  <div class="text-center mt-4" *ngIf="isLoading">
    <lh-shared-ui-spinner [visible]="isLoading"> </lh-shared-ui-spinner>
    <strong>{{ 'LOADING' | translate }}</strong>
  </div>

  <div *ngIf="bookings && !isLoading">
    <!-- Empty booking view messages -->
    <div *ngIf="bookings.length === 0" class="no-data-message">
      <div *ngIf="currentTab === 'Incidents'">{{ 'NO_INCIDENT_BOOKINGS' | translate }}</div>
      <div *ngIf="currentTab === 'Active'">{{ 'NO_ACTIVE_BOOKINGS' | translate }}</div>
      <div *ngIf="currentTab === 'All'">{{ 'NO_BOOKINGS' | translate }}</div>
    </div>

    <!-- List of bookings grouped by date -->
    <lh-grouped-list
      [data]="groupedBookings"
      (itemSelected)="navigateToBooking($event.value)"
      *ngIf="bookings.length > 0"
    ></lh-grouped-list>
  </div>

  <div class="booking-period bottom" *ngIf="isBottomDatePaginationVisible">
    <div class="text">
      {{ fromDate | lhMoment: 'MMM DD' | uppercaseFirstLetter }} - {{ toDate | lhMoment: 'MMM DD' }}
    </div>
    <button id="showEarlier" class="btn btn-default pagination" (click)="showEarlier()">
      <i class="icon-prev"></i>
    </button>
    <button id="showLater" class="btn btn-default pagination" (click)="showLater()">
      <i class="icon-next"></i>
    </button>
  </div>
</div>
